import { html } from "lit";
import { createContext, provide } from "@lit/context";
import "../../atom/Row/index.js";
import "../../atom/Column/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { prop } from "../../../decorators/prop/index.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { getGap, getTabsStyle } from "./utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
const tabContext = createContext(Symbol("TabsContext"));
let DsfTabs = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.value = "";
    this.dsf_direction = "horizontal";
    this.dsf_size = "medium";
    this.onTabChange = (evt) => {
      this.value = evt.detail;
    };
    this.ctx = {
      direction: this.dsf_direction,
      size: this.dsf_size,
      value: this.value
    };
  }
  updated(_changedProperties) {
    this.ctx = {
      ...this.ctx,
      direction: this.dsf_direction,
      size: this.dsf_size,
      value: this.value
    };
    super.updated(_changedProperties);
  }
  render() {
    if (this.dsf_direction === "horizontal") {
      return html`
        <dsf-col role="tablist" class="min-w-0 flex-auto">
          <dsf-row dsf_gap=${getGap(this)} class=${getTabsStyle(this)}>
            <slot @tab-change=${this.onTabChange}></slot>
          </dsf-row>
          <slot name=${this.value}></slot>
        </dsf-col>
      `;
    }
    return html`
      <dsf-row role="tablist" dsf_align="top" class="min-w-0 flex-auto">
        <dsf-col dsf_gap=${getGap(this)} class=${getTabsStyle(this)}>
          <slot @tab-change=${this.onTabChange}></slot>
        </dsf-col>
        <div class="min-w-0 flex-auto">
          <slot name=${this.value}></slot>
        </div>
      </dsf-row>
    `;
  }
};
__decorateClass([
  prop({ type: String, reflect: true })
], DsfTabs.prototype, "value", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfTabs.prototype, "dsf_direction", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfTabs.prototype, "dsf_size", 2);
__decorateClass([
  provide({ context: tabContext })
], DsfTabs.prototype, "ctx", 2);
DsfTabs = __decorateClass([
  defineElement("dsf-tabs")
], DsfTabs);
export {
  DsfTabs,
  tabContext
};
